import type { ReactNode } from "react";

type HeadingProps = {
  heading: string;
  text: ReactNode;
};

const Heading = ({ heading, text }: HeadingProps) => {
  return (
    <div className="auth_heading_wrapper">
      <h1 className="heading-style-h1">{heading}</h1>
      <p className="text-size-regular">{text}</p>
    </div>
  );
};

export default Heading;
